import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Track issues...`}</p>
    <h1>{`Motivation`}</h1>
    <p>{`Just want to contribute a bit back to community and also I heavily relies on conda on my environment setup. Conda compare brew it has advantage of self contains `}<a parentName="p" {...{
        "href": "../2018-11-18-conda-everything"
      }}>{`cross building environment`}</a>{` and more control to versioning.`}</p>
    <p>{`This post is just my tracking board in case I forgot these PR:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/conda-forge/staged-recipes/pull/12493"
        }}>{`neovim`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/conda-forge/staged-recipes/pull/12584"
        }}>{`fasd`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/conda-forge/staged-recipes/pull/13682"
        }}>{`zoxide`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/conda-forge/staged-recipes/pull/14598"
        }}>{`direnv`}</a></li>
    </ul>
    <h1>{`Problems`}</h1>
    <h2>{`Neovim`}</h2>
    <h3>{`Libtool Hardcoded Path`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Conda build env is not reproducible`}</p>
    </blockquote>
    <p>{`Remember conda is heavily home-folderable, it doesn't require root permission; it doesn't hardcoded path; so ...`}</p>
    <p>{`It's not right to have these:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`# Assembler program.`}</span>{`
`}<span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`AS`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"/Users/runner/miniforge3/conda-bld/libtool_1596899629849/_build_env/bin/x86_64-apple-darwin13.4.0-as"`}</span></code></pre></div>
    <p>{`Note Mac's libtool is different from GNU libtool. When you `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`brew install libtool`}</code>{` you are actually installing glibtool.`}</p>
    <p>{`Therefore when you build `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`libtool`}</code>{` with other environment, you get the relocation nightmare. One way to stop is to remove prefix e.g. like `}<a parentName="p" {...{
        "href": "https://github.com/conda-forge/libtool-feedstock/pull/22"
      }}>{`this`}</a>{` for all env vars and do some post built dirty removing.`}</p>
    <h3>{`Neovim Sticked to Lua5.1`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Multiversion & coexists package is hard in many pkg manager including Conda`}</p>
    </blockquote>
    <p>{`Lua5.1 is not back compatible since 5.3. So, things get more and more sticky. Multiple PR to solve, so there's no so far a conda-forge certified nvim pkg. If you are in a hurry, please try mine: `}<a parentName="p" {...{
        "href": "https://anaconda.org/daizeng1984/nvim"
      }}>{`https://anaconda.org/daizeng1984/nvim`}</a></p>
    <p>{`🥴I'm now dreaming neovim was `}<a parentName="p" {...{
        "href": "https://github.com/neovim/neovim/issues/8669"
      }}>{`written in Rust`}</a>{`.`}</p>
    <h2>{`Fasd`}</h2>
    <blockquote>
      <p parentName="blockquote">{`Command line (bash etc.) script has conflicting requirements`}</p>
    </blockquote>
    <p>{`The ticket is sticked to whether we should include bash in conda while conda itself is relies on bash. This is more a philosophy/belief type of argument. I realized don't have much time then and drop the conversation and later fell into new love zoxide, which is much faster and also kinds of migrating my pkg army to `}<a parentName="p" {...{
        "href": "../2020-10-24-nix-power"
      }}>{`Nix`}</a>{` which is more rootily powerful.`}</p>
    <h2>{`Zoxide`}</h2>
    <blockquote>
      <p parentName="blockquote">{`my z for conda`}</p>
    </blockquote>
    <p>{`Just created the ticket and rust recipes are pretty standard...`}</p>
    <p>{`Be `}<a parentName="p" {...{
        "href": "https://github.com/conda-forge/staged-recipes/pull/13208#issuecomment-726767185"
      }}>{`guided`}</a>{` to solve the license files for zoxide... and it goes smoothly.`}</p>
    <p>{`When upstream version changes, I used this temporary code to update licenses:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "python"
    }}><pre parentName="div" {...{
        "className": "language-python"
      }}><code parentName="pre" {...{
          "className": "language-python"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` json`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` requests`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` tarfile`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` gzip`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` io`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` itertools`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` re`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` io`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` os

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# output dir`}</span>{`
tmp_dir `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"./library_licenses"`}</span>{`
os`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`makedirs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`tmp_dir`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` exist_ok`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token boolean"
          }}>{`True`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

licenses `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` json`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`load`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token builtin"
          }}>{`open`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"dependencies.json"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
licenses_and_crate`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
skipping `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`for`}</span>{` i`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` l `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{` `}<span parentName="code" {...{
            "className": "token builtin"
          }}>{`enumerate`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`licenses`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
    name`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` version `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` l`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"name"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` l`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"version"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` name `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{` skipping`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
        `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`continue`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`print`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`name`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` version`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string-interpolation"
          }}><span parentName="span" {...{
              "className": "token string"
            }}>{`f"`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`i`}<span parentName="span" {...{
                "className": "token operator"
              }}>{`+`}</span><span parentName="span" {...{
                "className": "token number"
              }}>{`1`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`/`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span><span parentName="span" {...{
                "className": "token builtin"
              }}>{`len`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span>{`licenses`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`"`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    res `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` requests`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`get`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string-interpolation"
          }}><span parentName="span" {...{
              "className": "token string"
            }}>{`f"https://crates.io/api/v1/crates/`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`name`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`/`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`version`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`/download"`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    tf `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` tarfile`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`TarFile`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`fileobj`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`gzip`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`GzipFile`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`fileobj`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`io`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`BytesIO`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`res`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`content`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`mode`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'r'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    l`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"tarfile"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` tf
    licenses_and_crate`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string-interpolation"
          }}><span parentName="span" {...{
              "className": "token string"
            }}>{`f"`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`l`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`[`}</span><span parentName="span" {...{
                "className": "token string"
              }}>{`'name'`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`]`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`-`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`l`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`[`}</span><span parentName="span" {...{
                "className": "token string"
              }}>{`'version'`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`]`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`"`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` l

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`assert`}</span>{` `}<span parentName="code" {...{
            "className": "token builtin"
          }}>{`len`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`licenses_and_crate`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span>{` `}<span parentName="code" {...{
            "className": "token builtin"
          }}>{`len`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`skipping`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`==`}</span>{` `}<span parentName="code" {...{
            "className": "token builtin"
          }}>{`len`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`licenses`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

custom`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'ryu-1.0.3'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'LICENSE-APACHE'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"ansi_term-0.12.1"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"LICENCE"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"minreq-2.1.0"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"COPYING.md"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`

explicit_mit_licenses `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` license_file `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` missing`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`for`}</span>{` k`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`l `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{` licenses_and_crate`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`items`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
    tf `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` l`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"tarfile"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
    files `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`ti`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`name`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`split`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'/'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`for`}</span>{` ti `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{` tf`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`getmembers`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` `}<span parentName="code" {...{
            "className": "token builtin"
          }}>{`len`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`ti`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`name`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`split`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'/'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`==`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`2`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'LICENSE-MIT'`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{` files`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
        explicit_mit_licenses`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`append`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string-interpolation"
          }}><span parentName="span" {...{
              "className": "token string"
            }}>{`f"`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`l`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`[`}</span><span parentName="span" {...{
                "className": "token string"
              }}>{`'name'`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`]`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`"`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token string-interpolation"
          }}><span parentName="span" {...{
              "className": "token string"
            }}>{`f"`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`l`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`[`}</span><span parentName="span" {...{
                "className": "token string"
              }}>{`'version'`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`]`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`"`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`l`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"license"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'LICENSE-MIT'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`else`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
        matches `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{` f `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`for`}</span>{` f `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{` files `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` re`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`match`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"LICENSE*"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`f`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
        `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` `}<span parentName="code" {...{
            "className": "token builtin"
          }}>{`len`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`matches`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`==`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
            license_file`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`append`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string-interpolation"
          }}><span parentName="span" {...{
              "className": "token string"
            }}>{`f"`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`l`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`[`}</span><span parentName="span" {...{
                "className": "token string"
              }}>{`'name'`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`]`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`"`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token string-interpolation"
          }}><span parentName="span" {...{
              "className": "token string"
            }}>{`f"`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`l`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`[`}</span><span parentName="span" {...{
                "className": "token string"
              }}>{`'version'`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`]`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`"`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`l`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"license"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`matches`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
        `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`else`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
            `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` k `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{` custom`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
                license_file`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`append`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string-interpolation"
          }}><span parentName="span" {...{
              "className": "token string"
            }}>{`f"`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`l`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`[`}</span><span parentName="span" {...{
                "className": "token string"
              }}>{`'name'`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`]`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`"`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token string-interpolation"
          }}><span parentName="span" {...{
              "className": "token string"
            }}>{`f"`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`l`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`[`}</span><span parentName="span" {...{
                "className": "token string"
              }}>{`'version'`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`]`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`"`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`l`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"license"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`custom`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`k`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
            `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`else`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
                missing`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`append`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string-interpolation"
          }}><span parentName="span" {...{
              "className": "token string"
            }}>{`f"`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`l`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`[`}</span><span parentName="span" {...{
                "className": "token string"
              }}>{`'name'`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`]`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`"`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token string-interpolation"
          }}><span parentName="span" {...{
              "className": "token string"
            }}>{`f"`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`l`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`[`}</span><span parentName="span" {...{
                "className": "token string"
              }}>{`'version'`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`]`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`"`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`l`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"license"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`l`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'repository'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`


manual_missing `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
exception `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"clap_derive"`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` 
    `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"https://raw.githubusercontent.com/clap-rs/clap/master/LICENSE-APACHE"`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` `}<span parentName="code" {...{
            "className": "token builtin"
          }}>{`len`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`missing`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`for`}</span>{` m `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{` missing`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
        mname `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` m`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`3`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`split`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'.git'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`split`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'/'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`2`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
        mgitrepo `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` m`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`3`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`split`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'.git'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`split`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'/'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
        name `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` m`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
        version `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` m`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
        `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`#missing_licenses = list(x.strip() for x in m[2].split("OR"))`}</span>{`
        `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`#for ml in missing_licenses:`}</span>{`
        res `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` requests`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`get`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string-interpolation"
          }}><span parentName="span" {...{
              "className": "token string"
            }}>{`f"https://api.github.com/repos/`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`mname`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`/`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`mgitrepo`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`/license"`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
        mdata `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` res`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`json`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
        `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'download_url'`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{` mdata`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
            `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`with`}</span>{` `}<span parentName="code" {...{
            "className": "token builtin"
          }}>{`open`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`os`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`path`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`join`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`tmp_dir`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string-interpolation"
          }}><span parentName="span" {...{
              "className": "token string"
            }}>{`f"`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`name`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`-`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`version`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`-license"`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"wb"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`as`}</span>{` f`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
                download_url `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` mdata`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'download_url'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
                res `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` requests`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`get`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`download_url`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
                f`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`write`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`res`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`content`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
        `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`else`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
            `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` m`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{` exception`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
                `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`with`}</span>{` `}<span parentName="code" {...{
            "className": "token builtin"
          }}>{`open`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`os`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`path`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`join`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`tmp_dir`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string-interpolation"
          }}><span parentName="span" {...{
              "className": "token string"
            }}>{`f"`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`name`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`-`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`version`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`-license"`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"wb"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`as`}</span>{` f`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
                    download_url `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` exception`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`m`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
                    res `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` requests`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`get`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`download_url`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
                    f`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`write`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`res`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`content`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
            `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`else`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
                manual_missing`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`append`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`m`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

missing `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` manual_missing
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`print`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"\\nmissing libray licenses:"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`print`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"\\n"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`join`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token builtin"
          }}>{`str`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`l`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`for`}</span>{` l `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{` missing`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`print`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string-interpolation"
          }}><span parentName="span" {...{
              "className": "token string"
            }}>{`f"`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span><span parentName="span" {...{
                "className": "token builtin"
              }}>{`len`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span>{`explicit_mit_licenses`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{` having 'LICENSE-MIT', `}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span><span parentName="span" {...{
                "className": "token builtin"
              }}>{`len`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span>{`license_file`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{` having 'LICENSE*' or custom filename, `}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span><span parentName="span" {...{
                "className": "token builtin"
              }}>{`len`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span>{`missing`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{` licenses are missing!!!; in total `}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span><span parentName="span" {...{
                "className": "token builtin"
              }}>{`len`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span>{`licenses_and_crate`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`"`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`for`}</span>{` name`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` version`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` _`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` lic_name `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{` itertools`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`chain`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`explicit_mit_licenses`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` license_file`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
    key `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string-interpolation"
          }}><span parentName="span" {...{
              "className": "token string"
            }}>{`f"`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`name`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`-`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`version`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`"`}</span></span>{`
    tf `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` licenses_and_crate`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`key`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"tarfile"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`with`}</span>{` `}<span parentName="code" {...{
            "className": "token builtin"
          }}>{`open`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`os`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`path`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`join`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`tmp_dir`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string-interpolation"
          }}><span parentName="span" {...{
              "className": "token string"
            }}>{`f"`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`key`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`-license"`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"wb"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`as`}</span>{` f`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
        f`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`write`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`tf`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`extractfile`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string-interpolation"
          }}><span parentName="span" {...{
              "className": "token string"
            }}>{`f"`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`key`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`/`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`lic_name`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`"`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`read`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`replace`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`b'\\r\\n'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`b'\\n'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}</code></pre></div>
    {
      /* xcape */
    }
    {
      /* sdkman */
    }
    <h2>{`Direnv`}</h2>
    <blockquote>
      <p parentName="blockquote">{`How can this be missing! Let's fix that.`}</p>
    </blockquote>
    <p>{`😆 Turns out conda-forge's go is very `}<a parentName="p" {...{
        "href": "https://github.com/conda-forge/staged-recipes/pull/14598/commits/a9ebbac277b97c0f2df1ff339744616978b0b3a5"
      }}>{`easy`}</a>{`. Could feed more to conda-forge.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      